import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { API_ENDPOINTS } from './apiConfig';
import { useNavigate } from 'react-router-dom';

function InActiveAccount() {
  const { token } = useAuth();
  const [email, setEmail] = useState('');
  const [type, setType] = useState('1'); // 1: Delete, 0: Inactive
  const [errors, setErrors] = useState([]);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();


  useEffect(() => {
  if (!token || token.trim() === '') {
    navigate('/login');
  }
}, [token, navigate]);

  const validateEmail = (email) => {
    const re = /^[^\x00-\x1F\x7F\\"]{1,100}@[^@\s]+\.[^@\s]+$/;
    return re.test(email.trim().toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMessage('');

    const sanitizedEmail = email.trim().toLowerCase();

    if (!validateEmail(sanitizedEmail)) {
      setErrors(['Please enter a valid email address']);
      return;
    }

    if (!['0', '1'].includes(type)) {
      setErrors(['Please select a valid type']);
      return;
    }

    try {
      const res = await axios.post(API_ENDPOINTS.DELETEACOUNT, {
        email: sanitizedEmail,
        type: Number(type),
      }, {
        headers: { token },
      });

    if (res.data.result === 1) {
      setMessage('Account request processed successfully.');
    } else if (res.data.validateMail === 0) {
      setErrors(['Entered email does not match your email.']);
    } else if (res.data.errors) {
      setErrors(res.data.errors);
    } else {
      setErrors(['Something went wrong.']);
    }
    } catch (err) {
      console.error(err);
      setErrors(['Server error. Please try again later.']);
    }
  };

  return (
    <div
      className="container mt-4"
      style={{
        maxWidth: '600px',
        background: '#fff',
         paddingTop: '4rem', 
         paddingBottom: '2rem', 
        borderRadius: '12px',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      }}
    >
      <h6 className="text-center fw-bold mb-4 pt-6" style={{ color: '#ff69b4' }}>
        <i className="bi bi-person-dash-fill me-2"></i>Delete or Inactivate Account
      </h6>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label text-muted">Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            maxLength={100}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label text-muted">Type</label>
          <div className="d-flex gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="delete"
                name="type"
                value="1"
                checked={type === '1'}
                onChange={(e) => setType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="delete">
                Delete Account
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="inactive"
                name="type"
                value="0"
                checked={type === '0'}
                onChange={(e) => setType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="inactive">
                Inactivate Account
              </label>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="btn d-flex align-items-center justify-content-center gap-2 rounded-pill shadow-sm w-100"
          style={{
            backgroundColor: '#ff69b4',
            color: '#fff',
            padding: '10px 16px',
            fontSize: '15px',
            fontWeight: 500,
          }}
        >
          <i className="bi bi-trash3-fill"></i>
          Submit Request
        </button>

        {message && (
          <div className="alert alert-success mt-3">{message}</div>
        )}

        {errors.length > 0 && (
          <div className="alert alert-danger mt-3">
            <ul className="mb-0">
              {errors.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}
      </form>
    </div>
  );
}

export default InActiveAccount;
